import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationResponse } from '../../../../model/reservation';

interface IProps extends StyledComponentProps {
    reservationResponse?: reservationResponse;
    type: "add" | "delete";
    inProgress: boolean;
}


const ReservationSlotResponse = (props: IProps) => {

    const classes = props.classes;
    // 
    return (
        props.inProgress ?
            <Grid style={{ width: "100%" }}>
                {props.type === "add" ? "Prenotazione in Corso..." : "Eliminazione in corso..."}
                </Grid> :
            props.reservationResponse ? <Grid style={{ width: "100%" }}>
                <Typography > Esito: <span className={props.reservationResponse.result ? classes.SuccesfullResponse : classes.ErrorResponse}>{props.reservationResponse.message}</span> </Typography>
            </Grid> : <span></span>
    );
};
export default withStyles(styles as any)(ReservationSlotResponse)